module.exports = __webpack_public_path__ + "static/media/typeTwo.791292b3.png";